<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-chart-simple" />
        <span class="ml-1"
          >{{ newAdvancePaymentData.id > 0 ? "編輯" : "新增" }}預支資料</span
        >
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="預支編號："
                  label-for="id"
                  label-cols-md="3"
                  class="align-items-center"
                >
                  <div class="">
                    {{
                      newAdvancePaymentData.prepayment_number
                        ? newAdvancePaymentData.prepayment_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <!-- request_date -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_request_date"
                >
                  <b-form-group
                    label="預支申請日期："
                    label-for="request_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newAdvancePaymentData.request_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- user_id -->
              <b-col cols="12" md="12">
                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>申請人：</label>
                  <div class="input_wrap">
                    <v-select
                      id="user_id"
                      v-model="newAdvancePaymentData.user_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="applicantUserOptions"
                      :clearable="!isWorkerPageWithUserRestriction"
                      :disabled="isWorkerPageWithUserRestriction"
                      label="name_cn"
                      :reduce="(option) => option.id"
                      placeholder="選擇申請人"
                      :filter="userSearch"
                      @input="handleUserChange"
                    >
                      <template #option="{ roles, name_cn }">
                        <template v-if="roles && roles[0]">
                          [{{ roles[0].name }}] {{ name_cn }}
                        </template>
                        <template v-else>
                          {{ name_cn }}
                        </template>
                      </template>
                      <template #selected-option="{ roles, name_cn }">
                        <template v-if="roles && roles[0]">
                          [{{ roles[0].name }}] {{ name_cn }}
                        </template>
                        <template v-else>
                          {{ name_cn }}
                        </template>
                      </template>
                    </v-select>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" md="12">
                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>需要發票？</label>
                  <div class="input_wrap">
                    <b-form-checkbox
                      id="requires_invoice"
                      v-model="newAdvancePaymentData.requires_invoice"
                      name="requires_invoice"
                      switch
                      inline
                      :value="1"
                      :unchecked-value="0"
                      @change="handleRequiresInvoiceChange"
                    >
                    </b-form-checkbox>
                    {{
                      newAdvancePaymentData.requires_invoice === 1
                        ? "需要發票"
                        : "不需要發票"
                    }}
                  </div>
                </div>
              </b-col>
              <!-- invoice_id -->
              <b-col cols="12" md="12" v-if="newAdvancePaymentData.requires_invoice == 1">

                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>選擇發票：</label>
                  <div class="input_wrap">
                    <validation-provider
                      #default="validationContext"
                      name="發票"
                      :rules="newAdvancePaymentData.requires_invoice == 1 ? 'required' : ''"
                      vid="v_invoice_id"
                    >
                        <v-select
                          id="invoice_id"
                          v-model="newAdvancePaymentData.invoice_id"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="invoiceOptions"
                          :clearable="true"
                          label="invoice_number"
                          :reduce="(option) => option.id"
                          placeholder="選擇發票"
                          :key="`invoice-select-${invoiceOptions.length}-${newAdvancePaymentData.invoice_id}`"
                        >
                          <template #option="{ invoice_number, name_cn, address }">
                            [{{ invoice_number }}] {{ name_cn || '未指定客戶' }}{{ address ? ' ' + address : '' }}
                          </template>
                          <template #selected-option="{ invoice_number, name_cn, address }">
                            [{{ invoice_number }}] {{ name_cn || '未指定客戶' }}{{ address ? ' ' + address : '' }}
                          </template>
                        </v-select>
                        <b-form-invalid-feedback
                          :state="getValidationState(validationContext)"
                        >
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                    </validation-provider>
                    </div>
                  </div>
              </b-col>

              <!-- purpose -->
              <b-col cols="12" md="12">
                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>預支備註：</label>
                  <div class="input_wrap">
                    <b-form-textarea
                      id="purpose"
                      v-model="newAdvancePaymentData.purpose"
                      placeholder="輸入預支備註"
                      rows="3"
                    />
                  </div>
                </div>
              </b-col>



              <!-- order_number (隱藏但保留在資料庫) -->
              <b-col cols="12" md="6" v-if="false">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_order_number"
                >
                  <b-form-group
                    label="施工單號："
                    label-for="order_number"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="order_number"
                      v-model="newAdvancePaymentData.order_number"
                      placeholder="輸入施工單號"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                cols="12"
                md="6"
                v-if="
                  (ability.can('status', 'prepayments_form') &&
                    !is_user_page) ||
                  (ability.can('status', 'user_prepayments_form') &&
                    is_user_page)
                "
              >
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_prepayment_status_id"
                >
                  <b-form-group
                    label="預支狀態："
                    label-for="prepayment_status_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="prepayment_status_id"
                      v-model="newAdvancePaymentData.prepayment_status_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="prepaymentStatusOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="預支狀態"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- 收款方式 - 表單層級 -->
              <b-col cols="12" md="6" v-if="newAdvancePaymentData.prepayment_status_id == 4 &&  (ability.can('status', 'prepayments_form') &&
                    !is_user_page) ||
                  (ability.can('status', 'user_prepayments_form') &&
                    is_user_page)">
                <validation-provider
                  #default="validationContext"
                  name="收款方式"
                  rules="required"
                  vid="v_receive_method_id"
                >
                  <b-form-group
                    label="收款方式："
                    label-for="receive_method_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="receive_method_id"
                      v-model="newAdvancePaymentData.receive_method_id"
                      :options="receiveMethodOptions"
                      :filter="receiveMethodSearch"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇收款方式"
                      @input="handleMainReceiveMethodChange($event)"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- 收款日期 - 表單層級 -->
              <b-col cols="12" md="6" v-if="newAdvancePaymentData.prepayment_status_id == 4 &&  (ability.can('status', 'prepayments_form') &&
                    !is_user_page) ||
                  (ability.can('status', 'user_prepayments_form') &&
                    is_user_page) ">
                <validation-provider
                  #default="validationContext"
                  name="收款日期"
                  rules="required"
                  vid="v_receipt_date"
                >
                  <b-form-group
                    label="收款日期："
                    label-for="receipt_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      id="receipt_date"
                      v-model="newAdvancePaymentData.receipt_date"
                      class="form-control"
                      placeholder="選擇收款日期"
                      :config="{ dateFormat: 'Y-m-d' }"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- 支票號碼 - 表單層級 -->
              <b-col cols="12" md="6" v-if="shouldShowMainCheckNumber() &&  (ability.can('status', 'prepayments_form') &&
                    !is_user_page) ||
                  (ability.can('status', 'user_prepayments_form') &&
                    is_user_page) ">
                <validation-provider
                  #default="validationContext"
                  name="支票號碼"
                  rules="required"
                  vid="v_check_number"
                >
                  <b-form-group
                    label="支票號碼："
                    label-for="check_number"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="check_number"
                      v-model="newAdvancePaymentData.check_number"
                      placeholder="輸入支票號碼"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <hr />
            <!-- 預支買野 -->
            <div>
              <div class="mb-2 d-flex justify-content-between">
                <h5>預支金額</h5>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="addItem('transactions')"
                  size="sm"
                >
                  <feather-icon size="16" icon="PlusCircleIcon" />
                </b-button>
              </div>
              <b-row
                v-for="(
                  transaction, index
                ) in newAdvancePaymentData.transactions"
                :key="`transaction_${index}`"
                class="px-1"
              >
                <b-col
                  cols="12"
                  class="d-flex backgroundColor4 mb-1 radius-round border-1"
                >
                  <b-row class="flex-grow-1 p-2">

                    <!-- user_id (接收人) -->
                    <b-col cols="12" md="6">
                      <validation-provider
                        #default="validationContext"
                        :vid="`v_user_id${index}`"
                        name="此欄"
                        rules="required"
                      >
                        <b-form-group
                          label="接收人"
                          :label-for="`user_id${index}`"
                          label-cols-md="3"
                          class="required"
                        >
                          <v-select
                            :id="`user_id${index}`"
                            v-model="transaction.user_id"
                            :options="salaryUsersOptions"
                            :reduce="(option) => option.id"
                            label="name_cn"
                            placeholder="選擇接收人"
                            :filter="userSearch"
                            :key="`transaction-user-${index}-${trigger}`"
                            :clearable="!isWorkerPageWithUserRestriction"
                            :disabled="isWorkerPageWithUserRestriction"
                          >
                            <template #option="{ roles, name_cn }">
                              <template v-if="roles && roles[0]">
                                [{{ roles[0].name }}] {{ name_cn }}
                              </template>
                              <template v-else>
                                {{ name_cn }}
                              </template>
                            </template>
                            <template #selected-option="{ roles, name_cn }">
                              <template v-if="roles && roles[0]">
                                [{{ roles[0].name }}] {{ name_cn }}
                              </template>
                              <template v-else>
                                {{ name_cn }}
                              </template>
                            </template>
                          </v-select>
                          <b-form-invalid-feedback
                            :state="getValidationState(validationContext)"
                          >
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <!-- amount -->
                    <b-col cols="12" md="6">
                      <validation-provider
                        #default="validationContext"
                        :vid="`v_amount${index}`"
                        name="此欄"
                        rules="required"
                      >
                        <b-form-group
                          label="金額："
                          :label-for="`amount${index}`"
                          label-cols-md="3"
                          class="required"
                        >
                          <b-form-input
                            :id="`amount${index}`"
                            v-model="transaction.amount"
                            type="number"
                            step="0.01"
                            placeholder="輸入金額正數為預支，負數為退回"
                            :state="getValidationState(validationContext)"
                          />
                          <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>



                    <!-- create_id (負責人) - 隱藏但保留在資料結構中 -->
                    <b-col cols="12" md="6" v-if="false">
                      <validation-provider
                        #default="validationContext"
                        :vid="`v_create_id${index}`"
                        name="此欄"
                        rules="required"
                      >
                        <b-form-group
                          label="付款人"
                          :label-for="`create_id${index}`"
                          label-cols-md="3"
                          class="required"
                        >
                          <v-select
                            :id="`create_id${index}`"
                            v-model="transaction.create_id"
                            :options="userOptions"
                            :reduce="(option) => option.id"
                            label="name_cn"
                            placeholder="選擇付款人"
                            :filter="userSearch"
                          >
                            <template #option="{ roles, name_cn }">
                              <template v-if="roles && roles[0]">
                                [{{ roles[0].name }}] {{ name_cn }}
                              </template>
                              <template v-else>
                                {{ name_cn }}
                              </template>
                            </template>
                            <template #selected-option="{ roles, name_cn }">
                              <template v-if="roles && roles[0]">
                                [{{ roles[0].name }}] {{ name_cn }}
                              </template>
                              <template v-else>
                                {{ name_cn }}
                              </template>
                            </template>
                          </v-select>
                          <b-form-invalid-feedback
                            :state="getValidationState(validationContext)"
                          >
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <!-- description -->
                    <b-col cols="12" md="6">
                      <b-form-group
                        label="備註："
                        :label-for="`description${index}`"
                        label-cols-md="3"
                      >
                        <b-form-textarea
                          :id="`description${index}`"
                          v-model="transaction.description"
                          placeholder="輸入備註"
                          rows="3"
                        />
                      </b-form-group>
                    </b-col>

                    <!-- 批核狀態和批核備註 -->
                    <template
                      v-if="
                        (ability.can('salary_approve', 'prepayments_form') &&
                          !is_user_page) ||
                        (ability.can(
                          'salary_approve',
                          'user_prepayments_form'
                        ) &&
                          is_user_page)
                      "
                    >
                      <b-col cols="12">
                        <hr style="border-color: #e0e0e0" />
                      </b-col>

                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`v_approve_date${index}`"
                          name="批核日期"
                          :rules="(transaction.is_approved == 1 || transaction.is_rejected == 1) ? 'required' : ''"
                        >
                          <b-form-group
                            label="批核日期："
                            label-cols-md="3"
                            :class="(transaction.is_approved == 1 || transaction.is_rejected == 1) ? 'required' : ''"
                          >
                            <flat-pickr
                              v-model="transaction.approve_date"
                              class="form-control"
                              :config="{
                                allowInput: true,
                                altInput: true,
                                altFormat: 'Y-m-d',
                                dateFormat: 'Y-m-d',
                              }"
                              placeholder="輸入YYYY-MM-DD"
                              :disabled="!transaction.is_approved && !transaction.is_rejected"
                            />
                            <b-form-invalid-feedback
                              :state="getValidationState(validationContext)"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                        <b-form-group label="批核狀態：" label-cols-md="3">
                          <b-form-checkbox
                            v-model="transaction.is_approved"
                            value="1"
                            unchecked-value="0"
                            @change="
                              updateApprovalStatus(transaction, 'is_approved')
                            "
                          >
                            批核
                          </b-form-checkbox>
                          <b-form-checkbox
                            v-model="transaction.is_rejected"
                            value="1"
                            unchecked-value="0"
                            @change="
                              updateApprovalStatus(transaction, 'is_rejected')
                            "
                          >
                            拒絕
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" md="6">
                        <b-form-group label="批核備註：" label-cols-md="3">
                          <b-form-textarea
                            v-model="transaction.admin_remark"
                            placeholder="輸入批核備註"
                            rows="3"
                          />
                        </b-form-group>
                      </b-col>

                    </template>

                    <!-- 接收部分已移除 - 現在由表單層級管理 -->
                  </b-row>
                  <div
                    class="d-flex flex-column justify-content-between py-50 px-25"
                  >
                    <feather-icon
                      size="16"
                      icon="PlusIcon"
                      class="cursor-pointer text-success"
                      @click="addItem('transactions', index)"
                    />
                    <feather-icon
                      size="16"
                      icon="XIcon"
                      class="cursor-pointer text-danger"
                      @click="removeItem('transactions', index)"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
            <hr />
            <!-- <h5 class="mb-3">預支項目 (上單)</h5> -->
            <div>
              <p class="mb-2 d-flex justify-content-between">
                <span>工資</span
                >
                <b-button v-if="newAdvancePaymentData.salary_records && newAdvancePaymentData.salary_records.length == 0"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="addItem('salary_records')"
                  size="sm"
                >
                  <feather-icon size="16" icon="PlusCircleIcon" />
                </b-button>
              </p>
              <b-row
                v-for="(worker, index) in newAdvancePaymentData.salary_records"
                :key="`worker_${index}`"
                class="px-1"
              >
                <b-col
                  cols="12"
                  class="d-flex backgroundColor5 mb-1 radius-round border-1"
                >
                  <b-row class="flex-grow-1 p-2">
                    <!-- worker -->
                    <b-col cols="12" md="6">
                      <b-row>
                        <b-col cols="12">
                          <validation-provider
                            #default="validationContext"
                            :vid="`v_user_id${index}`"
                            name="此欄"
                            rules="required"
                          >
                            <b-form-group
                              :label="`員工(${index + 1})：`"
                              :label-for="`user_id${index}`"
                              label-cols-md="2"
                              class="required"
                            >
                              <div class="w-100">
                                <v-select
                                  v-model="worker.user_id"
                                  :options="salaryUsersOptions"
                                  label="name_cn"
                                  :reduce="(option) => option.id"
                                  :filter="userSearch"
                                  :clearable="!isWorkerPageWithUserRestriction"
                                  :disabled="isWorkerPageWithUserRestriction"
                                  :key="`worker-user-${index}-${trigger}`"
                                  placeholder="選擇員工"
                                  class="w-100"
                                  @input="handleWorkerChange(worker, $event)"
                                >
                                  <template #option="{ roles, name_cn }">
                                    <template v-if="roles && roles[0]">
                                      [{{ roles[0].name }}] {{ name_cn }}
                                    </template>
                                    <template v-else>
                                      {{ name_cn }}
                                    </template>
                                  </template>
                                  <template
                                    #selected-option="{ roles, name_cn }"
                                  >
                                    <template v-if="roles && roles[0]">
                                      [{{ roles[0].name }}] {{ name_cn }}
                                    </template>
                                    <template v-else>
                                      {{ name_cn }}
                                    </template>
                                  </template>
                                </v-select>
                                <b-form-invalid-feedback
                                  :state="getValidationState(validationContext)"
                                >
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <!-- 只有當選擇了員工後才顯示工資相關欄位 -->
                        <template v-if="worker.user_id">
                          <!-- salary -->
                          <b-col cols="12">
                            <b-row class="mb-1 cal-input-group">
                              <!-- postpone_date -->
                              <b-col md="2" class="label"> 工資: </b-col>
                              <b-col md="10" class="c_content">
                                <div
                                  class="content-wrapper d-flex align-items-center"
                                >
                                  <!-- 日薪 -->
                                  <template v-if="newAdvancePaymentData.salary_type == 1">
                                    <validation-provider
                                      #default="validationContext"
                                      :vid="`v_working_days${index}`"
                                      name="此欄"
                                      rules="required"
                                    >
                                      <b-input-group
                                        class="group1 w-100"
                                        size="md"
                                        append="日"
                                      >
                                        <b-form-input
                                          id="working_days"
                                          v-model="worker.working_days"
                                          type="number"
                                          step="0.5"
                                          min="0"
                                          placeholder="輸入工作日數"
                                          @blur="calTotalSalary(worker)"
                                          :state="
                                            getValidationState(validationContext)
                                          "
                                        />
                                      </b-input-group>
                                    </validation-provider>

                                    <div class="operator">*</div>

                                    <validation-provider
                                      #default="validationContext"
                                      :vid="`v_worker_day_salary${index}`"
                                      name="此欄"
                                      rules="required"
                                    >
                                      <b-input-group
                                        class="group2 w-100"
                                        size="md"
                                        prepend="$"
                                        append="每日"
                                      >
                                        <b-form-input
                                          :id="`worker_day_salary${index}`"
                                          v-model="worker.day_salary"
                                          type="number"
                                          step="0.01"
                                          min="0"
                                          placeholder="輸入每日工資"
                                          @blur="calTotalSalary(worker)"
                                          :state="
                                            getValidationState(validationContext)
                                          "
                                        />
                                      </b-input-group>
                                    </validation-provider>

                                    <div class="operator">=</div>

                                    <b-input-group
                                      class="group3"
                                      size="md"
                                      prepend="$"
                                    >
                                      <b-form-input
                                        id=""
                                        type="number"
                                        step="0.01"
                                        v-model="worker.total_salary"
                                        placeholder="0.00"
                                        class="bg-white"
                                      />
                                    </b-input-group>
                                  </template>

                                  <!-- 月薪或按項目 -->
                                  <template v-else>
                                    <validation-provider
                                      #default="validationContext"
                                      :vid="`v_total_salary${index}`"
                                      name="此欄"
                                      rules="required"
                                      class="w-100"
                                    >
                                      <b-input-group
                                        class="group2 w-100"
                                        size="md"
                                        prepend="$"
                                      >
                                        <!-- append="每月"-->
                                        <b-form-input
                                          :id="`total_salary${index}`"
                                          v-model="worker.total_salary"
                                          type="number"
                                          step="any"
                                          :placeholder="newAdvancePaymentData.salary_type == 2 ? '輸入月薪' : '輸入項目工資'"
                                          @blur="calTotalSalary(worker)"
                                          :state="
                                            getValidationState(validationContext)
                                          "
                                        />
                                      </b-input-group>
                                    </validation-provider>
                                  </template>
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                        </template>
                       
                      </b-row>
                    </b-col>

                    <b-col cols="12" md="6">
                      <!-- 只有當選擇了員工後才顯示日期選擇欄位 -->
                      <template v-if="worker.user_id">
                        <b-row>
                          <!-- 月薪 -->
                          <b-col cols="12" v-if="newAdvancePaymentData.salary_type == 2 || newAdvancePaymentData.salary_type == 1">
                            <validation-provider
                              #default="validationContext"
                              name="此欄"
                              rules="required"
                              vid="v_month"
                            >
                              <b-form-group
                                label="預支月份"
                                label-for="id"
                                label-cols-md="2"
                                class="required"
                              >
                                <flat-pickr
                                  v-model="worker.year_month"
                                  class="form-control"
                                  :config="monthPickerConfig"
                                  placeholder="輸入YYYY-MM"
                                />
                                <b-form-invalid-feedback
                                  :state="getValidationState(validationContext)"
                                >
                                  {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                          <b-col cols="12">
                          <b-form-group
                              label="計薪形式："
                              label-for="salary_type"
                              label-cols-md="2"
                            >
                              <div
                                class="form-control-plaintext"
                                :class="getSalaryTypeClass(newAdvancePaymentData.salary_type)"
                              >
                                {{ getSalaryTypeText(newAdvancePaymentData.salary_type) }}
                              </div>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </template>
                    </b-col>

                    <!-- 批核部分 -->
                    <template
                      v-if="
                        (ability.can('salary_approve', 'prepayments_form') &&
                          !is_user_page) ||
                        (ability.can(
                          'salary_approve',
                          'user_prepayments_form'
                        ) &&
                          is_user_page)
                      "
                    >
                      <b-col cols="12">
                        <hr style="border-color: #e0e0e0" />
                      </b-col>

                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`v_worker_approve_date${index}`"
                          name="批核日期"
                          :rules="(worker.is_approved == 1 || worker.is_rejected == 1) ? 'required' : ''"
                        >
                          <b-form-group
                            label="批核日期："
                            label-cols-md="3"
                            :class="(worker.is_approved == 1 || worker.is_rejected == 1) ? 'required' : ''"
                          >
                            <flat-pickr
                              v-model="worker.approve_date"
                              class="form-control"
                              :config="{
                                allowInput: true,
                                altInput: true,
                                altFormat: 'Y-m-d',
                                dateFormat: 'Y-m-d',
                              }"
                              placeholder="輸入YYYY-MM-DD"
                              :disabled="!worker.is_approved && !worker.is_rejected"
                            />
                            <b-form-invalid-feedback
                              :state="getValidationState(validationContext)"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                        <b-form-group label="批核狀態：" label-cols-md="3">
                          <b-form-checkbox
                            v-model="worker.is_approved"
                            value="1"
                            unchecked-value="0"
                            @change="
                              updateApprovalStatus(worker, 'is_approved')
                            "
                          >
                            批核
                          </b-form-checkbox>
                          <b-form-checkbox
                            v-model="worker.is_rejected"
                            value="1"
                            unchecked-value="0"
                            @change="
                              updateApprovalStatus(worker, 'is_rejected')
                            "
                          >
                            拒絕
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12" md="6">
                        <b-form-group label="批核備註：" label-cols-md="3">
                          <b-form-textarea
                            v-model="worker.admin_remark"
                            placeholder="輸入批核備註"
                            rows="3"
                          />
                        </b-form-group>
                      </b-col>

                    
                    </template>

                    <!-- 接收部分已移除 - 現在由表單層級管理 -->
                  </b-row>
                  <div
                    class="d-flex flex-column justify-content-between py-50 px-25"
                  >
                    <!-- <feather-icon
                      size="16"
                      icon="PlusIcon"
                      class="cursor-pointer text-success"
                      @click="addItem('salary_records', index)"
                    /> -->
                    <feather-icon
                      size="16"
                      icon="XIcon"
                      class="cursor-pointer text-danger"
                      @click="removeItem('salary_records', index)"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>


            <div class="d-flex justify-content-end">
              <b-col cols="12" md="6">
                <b-form-group
                  label="總預支金額："
                  label-for="total_amount"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-input
                    id="total_amount"
                    class="bg-white"
                    :value="newAdvancePaymentData.total_amount ? newAdvancePaymentData.total_amount.toFixed(2) : '0.00'"
                    :disabled="true"
                    placeholder="0.00"
                  />
                </b-form-group>
              </b-col>
            </div>

            <div class="d-flex justify-content-end">
              <b-col cols="12" md="6">
                <b-form-group
                  label="總接收金額："
                  label-for="received_amount"
                  label-cols-md="3"
                  class="required"
                >
                  <b-form-input
                    id="received_amount"
                    class="bg-white"
                    :value="newAdvancePaymentData.received_amount ? newAdvancePaymentData.received_amount.toFixed(2) : '0.00'"
                    :disabled="true"
                    placeholder="0.00"
                  />
                </b-form-group>
              </b-col>
            </div>

            <div class="d-flex justify-content-end">
              <b-col cols="12" md="6">
                <b-form-group
                  label="已使用金額(已批核)："
                  label-for="used_amount"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-input
                    id="used_amount"
                    class="bg-white"
                    :value="newAdvancePaymentData.used_amount ? newAdvancePaymentData.used_amount.toFixed(2) : '0.00'"
                    :disabled="true"
                    placeholder="0.00"
                  />
                </b-form-group>
              </b-col>
            </div>

            <div class="d-flex justify-content-end">
              <b-col cols="12" md="6">
                <b-form-group
                  label="待批核金額："
                  label-for="pending_amount"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-input
                    id="pending_amount"
                    class="bg-white"
                    :value="newAdvancePaymentData.pending_amount ? newAdvancePaymentData.pending_amount.toFixed(2) : '0.00'"
                    :disabled="true"
                    placeholder="0.00"
                  />
                </b-form-group>
              </b-col>
            </div>

            <div class="d-flex justify-content-end">
              <b-col cols="12" md="6">
                <b-form-group
                  label="已拒絕金額："
                  label-for="rejected_amount"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-input
                    id="rejected_amount"
                    class="bg-white"
                    :value="newAdvancePaymentData.rejected_amount ? newAdvancePaymentData.rejected_amount.toFixed(2) : '0.00'"
                    :disabled="true"
                    placeholder="0.00"
                  />
                </b-form-group>
              </b-col>
            </div>

            <div class="d-flex justify-content-end">
              <b-col cols="12" md="6">
                <b-form-group
                  label="已退還金額："
                  label-for="refunded_amount"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-input
                    id="refunded_amount"
                    class="bg-white"
                    :value="newAdvancePaymentData.refunded_amount ? newAdvancePaymentData.refunded_amount.toFixed(2) : '0.00'"
                    :disabled="true"
                    placeholder="0.00"
                  />
                </b-form-group>
              </b-col>
            </div>

            <div class="d-flex justify-content-end">
              <b-col cols="12" md="6">
                <b-form-group
                  label="餘額："
                  label-for="balance"
                  label-cols-md="3"
                  class=""
                >
                  <b-form-input
                    id="balance"
                    class="bg-white"
                    :value="newAdvancePaymentData.balance ? newAdvancePaymentData.balance.toFixed(2) : '0.00'"
                    :disabled="true"
                    placeholder="0.00"
                  />
                </b-form-group>
              </b-col>
            </div>

            <hr />

            <upload-file
              key="fileupload1"
              ref="childRef1"
              custome_id="1"
              :props_previewImage="newAdvancePaymentData.documents"
              file_delete_url="/prepayments/documents"
              v-on:file-uploaded="onFileUploaded"
            ></upload-file>
            <!-- deleteAdvancePaymentDocument -->
            <hr />

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BInputGroup,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, nextTick, getCurrentInstance } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@validations";
// import uploadFileSingle from "@/layouts/components/file/uploadFileSingle.vue";
import uploadFile from "@/layouts/components/file/uploadFile.vue";
import ability from "@/libs/acl/ability";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { months } from "@/libs/helper";

export default {
  data() {
    return {
      required,
      ability,
      months,
      trigger: false,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BInputGroup,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    // uploadFileSingle,
    uploadFile,
  },
  computed: {
    // 检查是否为worker页面且有user_id限制
    isWorkerPageWithUserRestriction() {
      return this.is_user_page && Boolean(this.$route.query.user_id);
    },
    // 获取受限制的用户ID
    restrictedUserId() {
      if (this.isWorkerPageWithUserRestriction) {
        return Number(this.$route.query.user_id);
      }
      return null;
    },
    // 申请人选项（在worker页面时只显示指定用户）
    applicantUserOptions() {
      if (this.isWorkerPageWithUserRestriction) {
        const userId = this.restrictedUserId;
        return this.userOptions.filter(user => user.id === userId);
      }
      return this.userOptions;
    },
    salaryUsersOptions() {
      // let baseOptions = [];
      
      // 如果有選擇項目且項目用戶選項不為空，使用項目用戶選項
      // if (this.newAdvancePaymentData.project_id && this.projectUsersOptions && this.projectUsersOptions.length > 0) {
      //   baseOptions = this.projectUsersOptions;
      // } else {
      //   // 否則使用所有用戶選項
      //   baseOptions = this.userOptions;
      // }

      // 如果是worker页面且有user_id限制，只返回指定用户
      if (this.isWorkerPageWithUserRestriction) {
        const userId = this.restrictedUserId;
        return this.userOptions.filter(user => user.id === userId);
      }

      return this.userOptions;
    },
  },
  methods: {
    monthSelectPlugin,
    getSalaryTypeText(salaryType) {
      if (salaryType == null) {
        return "請選擇收支者以決定計薪形式";
      }

      // 檢查當前用戶的計薪方式是否與 salary_type 一致
      if (this.newAdvancePaymentData.user_id && this.userOptions) {
        const selectedUser = this.userOptions.find(
          (user) => user.id === this.newAdvancePaymentData.user_id
        );
        if (selectedUser && selectedUser.payment_method_id !== salaryType) {
          const currentTypeName = this.getPaymentMethodName(salaryType);
          const userTypeName = this.getPaymentMethodName(
            selectedUser.payment_method_id
          );
          return `${currentTypeName}，該用戶已修改計薪形式為${userTypeName}`;
        }
      }

      // 正常顯示
      return this.getPaymentMethodName(salaryType);
    },
    getPaymentMethodName(methodId) {
      switch (Number(methodId)) {
        case 1:
          return "日薪";
        case 2:
          return "月薪";
        case 3:
          return "以工程項目計算";
        default:
          return "未知";
      }
    },
    getSalaryTypeClass(salaryType) {
      if (salaryType == null) {
        return "text-muted";
      }

      // 檢查當前用戶的計薪方式是否與 salary_type 一致
      if (this.newAdvancePaymentData.user_id && this.userOptions) {
        const selectedUser = this.userOptions.find(
          (user) => user.id === this.newAdvancePaymentData.user_id
        );
        if (selectedUser && selectedUser.payment_method_id !== salaryType) {
          return "text-warning";
        }
      }

      return "text-success";
    },
    handleWorkerChange(worker, userId) {
      console.log(`handleWorkerChange start`)
      if (!userId) return;
      // 查找選擇的用戶
      const selectedUser = this.salaryUsersOptions.find(user => user.id === userId);
      const salaryType = selectedUser.payment_method_id; 
      this.$set(this.newAdvancePaymentData, 'salary_type', salaryType);
      if (!selectedUser) return;

      // 只有在創建新預支記錄且新建工人記錄時才根據用戶的 payment_method_id 設置 salary_type
      // 編輯現有記錄時保持原有的 salary_type
      const isNewRecord = !worker.id || worker.id === 0;
      const isNewPrepayment = !this.newAdvancePaymentData.id || this.newAdvancePaymentData.id === 0;

      if (selectedUser.payment_method_id && isNewRecord && isNewPrepayment) {
        // 先清空日期值
        this.$set(worker, 'year_month', null);

        // 使用 Vue.$set 確保響應式更新
        this.$set(worker, 'salary_type', this.newAdvancePaymentData.salary_type);

        // 使用 nextTick 確保在 DOM 更新後執行
        this.$nextTick(() => {
          // 強制更新組件，確保界面反映最新狀態
          this.$forceUpdate();

          // 更新完成
        });
      }
    },
    handleRequiresInvoiceChange(value) {
      // 當切換發票需求時，清空發票選擇
      if (!value) {
        this.newAdvancePaymentData.invoice_id = null;
      }
    },
    // 處理表單層級的收款方式變化
    handleMainReceiveMethodChange(value) {
      // 如果不是支票，清空支票號碼
      if (value != 1) {
        this.newAdvancePaymentData.check_number = null;
      }
    },
    // 判斷是否顯示表單層級的支票號碼欄位
    shouldShowMainCheckNumber() {
      return this.newAdvancePaymentData.prepayment_status_id == 4 &&
             this.newAdvancePaymentData.receive_method_id == 1;
    },

    updateApprovalStatus(item, field) {
      if (field === "is_approved") {
        if (item.is_approved == 1 || item.is_approved == "1") {
          this.$set(item, "is_rejected", 0);
          // 自動填入當前日期
          const today = new Date().toISOString().split('T')[0];
          this.$set(item, "approve_date", today);
        } else {
          // 如果取消批核，清空日期
          this.$set(item, "approve_date", null);
        }
      } else if (field === "is_rejected") {
        if (item.is_rejected == 1 || item.is_rejected == "1") {
          this.$set(item, "is_approved", 0);
          // 自動填入當前日期
          const today = new Date().toISOString().split('T')[0];
          this.$set(item, "approve_date", today);
        } else {
          // 如果取消拒絕，清空日期
          this.$set(item, "approve_date", null);
        }
      }
      // 強制更新組件
      this.$forceUpdate();
    },



    userSearch(options, search) {
      return options.filter((item) => {
        return item.name_cn.toLowerCase().includes(search.toLowerCase()) || item.roles[0].name.toLowerCase().includes(search.toLowerCase());
      });
    },
    receiveMethodSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },


    hide() {
      if (this.$route.name === "worker-advance-payment-create" || this.$route.name === "worker-advance-payment-edit") {
        this.$router.replace("/worker/advance-payment/list");
        // this.$router.go(-1);
      } else {
        this.$router.replace("/advance-payment/list");
      }
    },
    onFileUploaded(file) {
      this.newAdvancePaymentData.image_files = file;
    },
    onSubmit() {
      // if (this.newAdvancePaymentData.id == 0 && this.newAdvancePaymentData.file) return;

      // 檢查是否至少有一個 transactions 或 salary_records 項目
      const hasTransactions = this.newAdvancePaymentData.transactions && this.newAdvancePaymentData.transactions.length > 0;
      const hasSalaryRecords = this.newAdvancePaymentData.salary_records && this.newAdvancePaymentData.salary_records.length > 0;

      if (!hasTransactions && !hasSalaryRecords) {
        this.makeToast("danger", "Warning", "請至少輸入一個預支金額記錄或工資記錄。");
        return;
      }

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          // 處理年月轉換邏輯 - 從 salary_records 的 year_month 提取到表單層級
          if (this.newAdvancePaymentData.salary_records && this.newAdvancePaymentData.salary_records.length > 0) {
            const firstRecord = this.newAdvancePaymentData.salary_records[0];
            if (firstRecord.year_month) {
              if (typeof firstRecord.year_month === "string") {
                const [month, year] = firstRecord.year_month.split(" ");
                this.newAdvancePaymentData.salary_year = parseInt(year);
                this.newAdvancePaymentData.salary_month = months.indexOf(month)+1;
              } else if (firstRecord.year_month instanceof Date) {
                this.newAdvancePaymentData.salary_year = firstRecord.year_month.getFullYear();
                this.newAdvancePaymentData.salary_month = firstRecord.year_month.getMonth() + 1;
              }
            }
          }

          // 自動設置發票關聯到所有 salary_records
          if (this.newAdvancePaymentData.invoice_id && this.newAdvancePaymentData.salary_records) {
            this.newAdvancePaymentData.salary_records.forEach(record => {
              record.invoice_id = this.newAdvancePaymentData.invoice_id;
            });
          }

          let formData = new FormData();

          formData.append("id", this.newAdvancePaymentData.id);
          formData.append(
            "order_number",
            this.newAdvancePaymentData.order_number
          );

          if (
            (ability.can("status", "prepayments_form") && !this.is_user_page) ||
            (ability.can("status", "user_prepayments_form") &&
              this.is_user_page)
          ) {
            formData.append(
              "prepayment_status_id",
              this.newAdvancePaymentData.prepayment_status_id
            );
          }

          // 添加發票相關欄位
          formData.append("requires_invoice", this.newAdvancePaymentData.requires_invoice);
          if (this.newAdvancePaymentData.invoice_id) {
            formData.append("invoice_id", this.newAdvancePaymentData.invoice_id);
          }

          formData.append(
            "request_date",
            this.newAdvancePaymentData.request_date
          );
          if (this.newAdvancePaymentData.purpose) {
            formData.append("purpose", this.newAdvancePaymentData.purpose);
          }

          formData.append("user_id", this.newAdvancePaymentData.user_id);

          // 添加表單層級的收款相關字段
          if (this.newAdvancePaymentData.receive_method_id) {
            formData.append("receive_method_id", this.newAdvancePaymentData.receive_method_id);
          }
          if (this.newAdvancePaymentData.receipt_date) {
            formData.append("receipt_date", this.newAdvancePaymentData.receipt_date);
          }
          if (this.newAdvancePaymentData.check_number) {
            formData.append("check_number", this.newAdvancePaymentData.check_number);
          }
          if (this.newAdvancePaymentData.salary_year) {
            formData.append("salary_year", this.newAdvancePaymentData.salary_year);
          }
          if (this.newAdvancePaymentData.salary_month) {
            formData.append("salary_month", this.newAdvancePaymentData.salary_month);
          }
          formData.append("salary_type", this.newAdvancePaymentData.salary_type);
          if (
            this.newAdvancePaymentData.transactions &&
            this.newAdvancePaymentData.transactions.length > 0
          ) {
            // 定義 prepayment_transactions 表允許的欄位
            const allowedTransactionFields = [
              'id', 'prepayment_id', 'create_id', 'user_id', 'amount',
              'description', 'is_approved', 'is_rejected', 'admin_remark', 'approve_date'
            ];

            for (
              let i = 0;
              i < this.newAdvancePaymentData.transactions.length;
              i++
            ) {
              const transaction = this.newAdvancePaymentData.transactions[i];
              for (let key of allowedTransactionFields) {
                if (transaction.hasOwnProperty(key)) {
                  const value = transaction[key];
                  formData.append(
                    `transactions[${i}][${key}]`,
                    value !== undefined && value !== null ? value : ''
                  );
                }
              }
            }
          }

          if (
            this.newAdvancePaymentData.salary_records &&
            this.newAdvancePaymentData.salary_records.length > 0
          ) {
            // 定義 salary_records 表允許的欄位
            const allowedSalaryFields = [
              'id', 'expense_id', 'prepayment_id', 'claim_id', 'salary_summary_id',
              'user_id', 'invoice_id', 'project_id', 'working_days', 'day_salary',
              'is_monthly', 'ot_hours', 'ot_amount', 'mpf_employer', 'mpf_employee',
              'commission', 'allowance', 'allowance_remark', 'total_salary', 'remark',
              'is_approved', 'is_rejected', 'admin_remark', 'approve_date'
            ];

            for (
              let i = 0;
              i < this.newAdvancePaymentData.salary_records.length;
              i++
            ) {
              const salaryRecord = this.newAdvancePaymentData.salary_records[i];
              for (let key of allowedSalaryFields) {
                if (salaryRecord.hasOwnProperty(key)) {
                  const value = salaryRecord[key];
                  formData.append(
                    `salary_records[${i}][${key}]`,
                    value !== undefined && value !== null ? value : ''
                  );
                }
              }
            }
          }



          // formData.append(
          //   "expenditure",
          //   this.newAdvancePaymentData.total_amount
          // );

          if (
            this.newAdvancePaymentData.image_files &&
            this.newAdvancePaymentData.image_files.length > 0
          ) {
            this.newAdvancePaymentData.image_files.forEach((item) => {
              formData.append("documents[]", item);
            });
          }
          // if (this.newAdvancePaymentData.image_files && this.newAdvancePaymentData.image_files > 0) {
          //     for (
          //       let i = 0;
          //       i < this.newAdvancePaymentData.image_files.length;
          //       i++
          //     ) {
          //     if (this.newAdvancePaymentData.image_files[i].size >= 2097152) {
          //       this.$toast({
          //         component: ToastificationContent,
          //         props: {
          //           title: "Error! Your Image size is larger then 2M",
          //           icon: "AlertTriangleIcon",
          //           variant: "danger",
          //         },
          //       });
          //       return false;
          //     } else {
          //       formData.append(
          //         "documents[]",
          //         this.newAdvancePaymentData.image_files[i]
          //       );
          //     }
          //   }
          // }

          store
            .dispatch("advance-payment/editAdvancePayment", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

              this.hide();

              // if (this.newAdvancePaymentData.id == 0) {
              //   this.newAdvancePaymentData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    addItem(key, index) {
      if (!this.newAdvancePaymentData[key]) {
        this.$set(this.newAdvancePaymentData, key, []);
      }
      let newItem = JSON.parse(JSON.stringify({ id: 0 }));

      if (key == "transactions") {
        newItem = JSON.parse(
          JSON.stringify({
            id: 0,
            create_id: this.newAdvancePaymentData.user_id, // 使用申請人作為創建者
            user_id: this.newAdvancePaymentData.user_id,
            amount: 0,
            prepayment_id: null,
            description: null,
            is_approved: 0,
            is_rejected: 0,
            admin_remark: null,
            approve_date: null,
            // 移除了以下字段，現在由表單層級管理：
            // is_received, receive_date, receive_method_id, check_number
          })
        );
      } else if (key == "salary_records") {
        newItem = JSON.parse(
          JSON.stringify({
            id: 0,
            is_monthly: 0,
            user_id: this.newAdvancePaymentData.user_id,
            working_days: 0,
            day_salary: 0,
            total_salary: 0,
            year_month: "", // 保留此字段用於前端顯示
            remark: "",
            is_approved: 0,
            is_rejected: 0,
            admin_remark: null,
            approve_date: null,
            // 自動設置發票關聯
            invoice_id: this.newAdvancePaymentData.invoice_id,
            // 移除了以下字段，現在由表單層級管理：
            // working_date, salary_year, salary_month, is_received, salary_receive_method_id, receive_date, check_number
          })
        );
      }

      if (index !== undefined) {
        this.newAdvancePaymentData[key].splice(index + 1, 0, newItem);
      } else {
        this.newAdvancePaymentData[key].push(newItem);
      }

      // 檢查是否是第一個項目，如果是且有申請人，則自動填入
      const isFirstItem = this.newAdvancePaymentData[key].length === 1;
      if (isFirstItem && this.newAdvancePaymentData.user_id) {
        if (key === "transactions") {
          this.$set(newItem, 'user_id', this.newAdvancePaymentData.user_id);
        } else if (key === "salary_records") {
          this.$set(newItem, 'user_id', this.newAdvancePaymentData.user_id);
          // 觸發 handleWorkerChange
          this.handleWorkerChange(newItem, this.newAdvancePaymentData.user_id);
        }
      }
    },
    removeItem(key, index) {
      // 直接移除項目，不檢查最小數量限制
      this.newAdvancePaymentData[key].splice(index, 1);
      this.updateTotalAmount();
    },

    handleUserChange() {

      // 自動填入申請人到所有 transactions 和 salary_records 項目
      this.autoFillUserToItems();

    },
    autoFillUserToItems() {
      console.log(`autoFillUserToItems start`)
      const selectedUserId = this.newAdvancePaymentData.user_id;

      if (selectedUserId) {
        
        // 只自動填入第一個 transactions 項目的 user_id（接收人）
        if (this.newAdvancePaymentData.transactions && this.newAdvancePaymentData.transactions.length > 0) {
          const firstTransaction = this.newAdvancePaymentData.transactions[0];
          this.$set(firstTransaction, 'user_id', selectedUserId);
        }

        // 只自動填入第一個 salary_records 項目的 user_id（員工）
        if (this.newAdvancePaymentData.salary_records && this.newAdvancePaymentData.salary_records.length > 0) {
          const firstWorker = this.newAdvancePaymentData.salary_records[0];
          const oldUserId = firstWorker.user_id;
          this.$set(firstWorker, 'user_id', selectedUserId);

          // 如果 user_id 有變更，手動觸發 handleWorkerChange
          if (oldUserId !== selectedUserId) {
            this.handleWorkerChange(firstWorker, selectedUserId);
          }
        }
      }
    },


  },
  watch: {
    "newAdvancePaymentData.transactions": {
      deep: true,
      handler() {
        this.updateTotalAmount();
        this.updateReceivedAmount();
        this.updateUsedAmount();
        this.updateRejectedAmount();
        this.updatePendingAmount();
        this.updateRefundedAmount();
        this.updateBalance();
      },
    },
    "newAdvancePaymentData.salary_records": {
      deep: true,
      handler() {
        this.updateTotalAmount();
        this.updateReceivedAmount();
        this.updateUsedAmount();
        this.updateRejectedAmount();
        this.updatePendingAmount();
        this.updateRefundedAmount();
        this.updateBalance();
      },
    },
    "newAdvancePaymentData.prepayment_status_id": {
      handler() {
        this.updateReceivedAmount();
        this.updateUsedAmount();
        this.updateRejectedAmount();
        this.updatePendingAmount();
        this.updateRefundedAmount();
        this.updateBalance();
      },
    },
    // 監聽發票選擇變化，自動設置到所有 salary_records
    "newAdvancePaymentData.invoice_id": {
      handler(newInvoiceId) {
        if (this.newAdvancePaymentData.salary_records && this.newAdvancePaymentData.salary_records.length > 0) {
          this.newAdvancePaymentData.salary_records.forEach(worker => {
            this.$set(worker, 'invoice_id', newInvoiceId);
          });
        }
      },
    },

  },
  props: {
    advancePaymentData: {
      type: Object,
      required: true,
    },
    userOptions: {
      type: Array,
      required: true,
    },
    receiveMethodOptions: {
      type: Array,
      required: true,
    },

    prepaymentStatusOptions: {
      type: Array,
      required: true,
    },
    invoiceOptions: {
      type: Array,
      required: true,
    },
    role: {},
    is_user_page: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    // 使用 props.advancePaymentData 初始化，如果不存在則使用預設值
    const newAdvancePaymentData = ref(props.advancePaymentData || {
      id: 0,
      total_amount: null,
      user_id: null,
      project_id: null,
      received_amount: null,
      used_amount: null,
      pending_amount: null,
      rejected_amount: null,
      refunded_amount: null,
      balance: null,
      requires_invoice: 0,
      invoice_id: null,
      prepayment_status_id: null,
      // 新增的表單層級收款相關字段
      receive_method_id: null,
      receipt_date: null,
      check_number: null,
      salary_year: null,
      salary_month: null,
      salary_type: null,
      salary_records: [],

      transactions: [
        {
          id: 0,
          create_id: null,
          user_id: null,
          amount: 0,
          prepayment_id: null,
          description: null,
          is_approved: 0,
          is_rejected: 0,
          admin_remark: null,
          approve_date: null,
          // 移除了以下字段，現在由表單層級管理：
          // is_received, receive_date, receive_method_id, check_number
        },
      ],
    });


    const trigger = ref(false);


    watch(
      () => props.advancePaymentData,
      (newVal) => {
        if (newVal) {
          newAdvancePaymentData.value = newVal;
        }
      },
      { immediate: true, deep: true }
    );

    // 監聽 userOptions 變化
    watch(
      () => props.userOptions,
      () => {
        // 強制更新 trigger 以確保 v-select 重新渲染
        trigger.value = !trigger.value;
      },
      { immediate: true }
    );


    // 監聽 prepaymentStatusOptions 變化，設定預設值
    watch(
      () => props.prepaymentStatusOptions,
      (newOptions) => {
        if (newOptions && newOptions.length > 0 && newAdvancePaymentData.value.id === 0 && !newAdvancePaymentData.value.prepayment_status_id) {
          // 尋找「預支待批核中」選項
          const defaultStatus = newOptions.find(option =>
            option.name === '預支待批核中' ||
            option.name.includes('待批核') ||
            option.name.includes('pending')
          );

          if (defaultStatus) {
            newAdvancePaymentData.value.prepayment_status_id = defaultStatus.id;
          } else if (newOptions.length > 0) {
            // 如果找不到特定選項，使用第一個選項作為預設值
            newAdvancePaymentData.value.prepayment_status_id = newOptions[0].id;
          }
        }
      },
      { immediate: true }
    );

    // 監聽路由變化，在worker頁面自動填入用戶
    watch(
      () => [props.is_user_page, props.userOptions],
      ([isUserPage, userOptions]) => {
        if (isUserPage && userOptions && userOptions.length > 0) {
          // 檢查URL是否包含user_id參數
          const urlParams = new URLSearchParams(window.location.search);
          const userId = urlParams.get('user_id');
          
          if (userId && newAdvancePaymentData.value.id === 0) {
            const userIdNum = Number(userId);
            
            // 設置申請人
            if (!newAdvancePaymentData.value.user_id) {
              newAdvancePaymentData.value.user_id = userIdNum;
            }
            
            // 自動填入第一個預支金額的接收人
            if (newAdvancePaymentData.value.transactions && newAdvancePaymentData.value.transactions.length > 0) {
              if (!newAdvancePaymentData.value.transactions[0].user_id) {
                newAdvancePaymentData.value.transactions[0].user_id = userIdNum;
              }
            }
            
            // 自動填入第一個工資記錄的員工
            if (newAdvancePaymentData.value.salary_records && newAdvancePaymentData.value.salary_records.length > 0) {
              if (!newAdvancePaymentData.value.salary_records[0].user_id) {
                newAdvancePaymentData.value.salary_records[0].user_id = userIdNum;

                // 直接設置計薪形式
                // 查找選擇的用戶並設置 salary_type
                console.log('設置用戶ID:', userIdNum, '用戶選項:', userOptions);
                nextTick(() => {
                  if (userOptions && userOptions.length > 0) {
                    const selectedUser = userOptions.find(user => user.id === userIdNum);
                    console.log('找到的用戶:', selectedUser);
                    if (selectedUser && selectedUser.payment_method_id) {
                      console.log('設置計薪形式:', selectedUser.payment_method_id);
                      // 設置表單層級的 salary_type
                      newAdvancePaymentData.value.salary_type = selectedUser.payment_method_id;
                      // 設置工資記錄的 salary_type
                      newAdvancePaymentData.value.salary_records[0].salary_type = selectedUser.payment_method_id;
                      console.log('設置完成，當前 salary_type:', newAdvancePaymentData.value.salary_type);
                    } else {
                      console.log('用戶未找到或沒有 payment_method_id');
                    }
                  } else {
                    console.log('userOptions 為空或未載入');
                  }
                });
              }
            }
          }
        }
      },
      { immediate: true, deep: true }
    );

    

    const calTotalSalary = (item) => {
      if (item.salary_type == 1 && item.working_days && item.day_salary) {
        // 日薪計算：工作日數 × 每日工資
        const workingDays = parseFloat(item.working_days) || 0;
        const daySalary = parseFloat(item.day_salary) || 0;
        item.total_salary = Math.round(workingDays * daySalary * 100) / 100;
      }
      // 月薪和項目工資不需要自動計算，由用戶直接輸入
    };


    const updateTotalAmount = () => {
      // 預支金額 array 中所有 item 的金額相加
      const transactionSum = newAdvancePaymentData.value.transactions && newAdvancePaymentData.value.transactions.length > 0 ?
        newAdvancePaymentData.value.transactions
        .reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0) : 0;

      // 工資 array 中所有 item 的金額相加
      const salarySum = newAdvancePaymentData.value.salary_records && newAdvancePaymentData.value.salary_records.length > 0 ?
        newAdvancePaymentData.value.salary_records
        .reduce((sum, item) => sum + (parseFloat(item.total_salary) || 0), 0) : 0;

      const totalAmount = transactionSum + salarySum;
      newAdvancePaymentData.value.total_amount = Math.round(totalAmount * 100) / 100;
    };

    const updateReceivedAmount = () => {
       let totalReceived = 0;
      // 已收款金額 = 已批核金額
      if(newAdvancePaymentData.value.prepayment_status_id == 4){
        // 預支金額 array 中選了已接收狀態的 item 的金額相加
        
        const transactionSum = newAdvancePaymentData.value.transactions && newAdvancePaymentData.value.transactions.length > 0 ?
          newAdvancePaymentData.value.transactions
          .filter((t) => parseInt(t.is_rejected) !== 1)
          .reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0) : 0;

        // 工資 array 中選了已接收狀態的 item 的金額相加
        const salarySum = newAdvancePaymentData.value.salary_records && newAdvancePaymentData.value.salary_records.length > 0 ?
          newAdvancePaymentData.value.salary_records
          .filter((item) => parseInt(item.is_rejected) !== 1)
          .reduce((sum, item) => sum + (parseFloat(item.total_salary) || 0), 0) : 0;

        totalReceived = transactionSum + salarySum;
      }
      newAdvancePaymentData.value.received_amount = Math.round(totalReceived * 100) / 100;
    };

    const updateUsedAmount = () => {
      // 預支金額 array 中選了批核狀態的 item 的金額相加
      const transactionSum = newAdvancePaymentData.value.transactions && newAdvancePaymentData.value.transactions.length > 0 ?
        newAdvancePaymentData.value.transactions
        .filter((item) => parseInt(item.is_approved) === 1)
        .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) : 0;

      // 工資 array 中選了批核狀態的 item 的金額相加
      const salarySum = newAdvancePaymentData.value.salary_records && newAdvancePaymentData.value.salary_records.length > 0 ?
        newAdvancePaymentData.value.salary_records
        .filter((item) => parseInt(item.is_approved) === 1)
        .reduce((sum, item) => sum + (parseFloat(item.total_salary) || 0), 0) : 0;

      const totalUsed = transactionSum + salarySum;
      newAdvancePaymentData.value.used_amount = Math.round(totalUsed * 100) / 100;
    };

    const updatePendingAmount = () => {
      // 待批核金額 = 總預支金額 - 已使用金額(已批核) - 已拒絕金額
      const totalAmount = newAdvancePaymentData.value.total_amount || 0;
      const usedAmount = newAdvancePaymentData.value.used_amount || 0;
      const rejectedAmount = newAdvancePaymentData.value.rejected_amount || 0;

      const pendingAmount = totalAmount - usedAmount - rejectedAmount;
      newAdvancePaymentData.value.pending_amount = Math.round(pendingAmount * 100) / 100;
    };

    const updateRejectedAmount = () => {
      // 預支金額 array 中選了拒絕狀態的 item 的金額相加
      const transactionSum = newAdvancePaymentData.value.transactions  && newAdvancePaymentData.value.transactions.length > 0 ?
        newAdvancePaymentData.value.transactions
        .filter((item) => parseInt(item.is_rejected) === 1)
        .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) : 0;

      // 工資 array 中選了拒絕狀態的 item 的金額相加
      const salarySum = newAdvancePaymentData.value.salary_records && newAdvancePaymentData.value.salary_records.length > 0 ?
        newAdvancePaymentData.value.salary_records
        .filter((item) => parseInt(item.is_rejected) === 1)
        .reduce((sum, item) => sum + (parseFloat(item.total_salary) || 0), 0) : 0;

      const totalRejected = transactionSum + salarySum;
      newAdvancePaymentData.value.rejected_amount = Math.round(totalRejected * 100) / 100;
    };

    const updateRefundedAmount = () => {
      // 預支金額 array 中所有 item 的有負的金額相加（取絕對值）
      const transactionRefund = newAdvancePaymentData.value.transactions && newAdvancePaymentData.value.transactions.length > 0 ?
        newAdvancePaymentData.value.transactions
        .filter((t) => parseFloat(t.amount) < 0)
        .reduce((sum, t) => sum + Math.abs(parseFloat(t.amount) || 0), 0) : 0;

      // 工資 array 中所有 item 的有負的金額相加（取絕對值）
      const salaryRefund = newAdvancePaymentData.value.salary_records && newAdvancePaymentData.value.salary_records.length > 0 ?
        newAdvancePaymentData.value.salary_records
        .filter((item) => parseFloat(item.total_salary) < 0)
        .reduce((sum, item) => sum + Math.abs(parseFloat(item.total_salary) || 0), 0) : 0;

      const totalRefunded = transactionRefund + salaryRefund;
      newAdvancePaymentData.value.refunded_amount = Math.round(totalRefunded * 100) / 100;
    };

    const updateBalance = () => {
      const receivedAmount = newAdvancePaymentData.value.received_amount || 0;
      const usedAmount = newAdvancePaymentData.value.used_amount || 0;
      const refundedAmount = Math.abs(newAdvancePaymentData.value.refunded_amount || 0); // 取絕對值，因為退還金額是負數

      const balance = receivedAmount - usedAmount - refundedAmount;
      newAdvancePaymentData.value.balance = Math.round(balance * 100) / 100;
    };

    const resetAdvancePaymentData = () => {
      newAdvancePaymentData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          requires_invoice: 0,
          invoice_id: null,
          transactions: [{ id: 0 }],
          salary_records: [{ id: 0 }],

        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } = formValidation(
      resetAdvancePaymentData
    );


    const monthPickerConfig = {
      allowInput: true,
      altInput: true,
      altFormat: "Y-m",
      dateFormat: "Y-m",
      plugins: [monthSelectPlugin()],
      enableTime: false,
      static: true,
    };

    const multiDatePickerConfig = {
      allowInput: true,
      altInput: true,
      altFormat: "Y-m-d",
      mode: "multiple",
      dateFormat: "Y-m-d",
      static: false,
      plugins: [],
    };

    const rangeDatePickerConfig = {
      allowInput: true,
      altInput: true,
      altFormat: "Y-m-d",
      mode: "range",
      dateFormat: "Y-m-d",
      static: false,
      plugins: [],
    };

    const userSelfData = ref(null);
    userSelfData.value = JSON.parse(localStorage.getItem("userData"));

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newAdvancePaymentData,

      calTotalSalary,

      updateTotalAmount,
      updateReceivedAmount,
      updateUsedAmount,
      updatePendingAmount,
      updateRejectedAmount,
      updateRefundedAmount,
      updateBalance,
      trigger,
      monthPickerConfig,
      multiDatePickerConfig,
      rangeDatePickerConfig,
      userSelfData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "~flatpickr/dist/plugins/monthSelect/style.css";
</style>

<style lang="scss" scoped></style>
